import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JwtTokenService } from '../services/auth/jwt-token.service';
import { AuthDialogService } from '../services/auth/auth-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private jwtTokenService: JwtTokenService,
    private authDialogService: AuthDialogService
  ) {}

  canActivate(): Observable<boolean> {
    return this.jwtTokenService.getIsLogin().pipe(
      map((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.authDialogService.openLogin();
          return false;
        }
        return true;
      })
    );
  }
}
